import dayjs from 'dayjs';

export const formatDuration = (duration: number): string => {
  let str = '';

  const ddur = dayjs.duration({ seconds: duration });

  const totalMinutes = Math.round(ddur.asMinutes());
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (Number(hours)) {
    str += `${hours} h`;
  }

  if (str || Number(minutes)) {
    str += ` ${minutes} min`;
  }

  return str ? str.trim() : '—';
};
